<template>
  <div>
    <fixed-header :title="pageTitle" :listPage="'/parts'" hideNewOfferBtn>
      <template v-slot:center>
        <info-data
          label="In Stock"
          horizontal
        >
          {{part.onHand}}
        </info-data>

        <info-data
          label="Allocated"
          horizontal
        >
          {{part.allocated}}
        </info-data>

        <info-data
          label="Available"
          horizontal
        >
          {{part.available}}
        </info-data>
        <info-data
          label="Updated"
          horizontal
        >
          {{ date(partUpdated) }}
        </info-data>
      </template>

      <!-- <b-button size="sm" @click="updatePart(part)">Save Part</b-button> -->
    </fixed-header>

    <b-card class="mb-2" body-class="margin-top-fixed-header">
      <part-form :partId="partId" @cancel="onClose" @partCreated="onPartCreated" @partUpdated="onPartUpdated" @partCopy="onPartCopy" />
    </b-card>

    <b-card>
<!--      <lower-tab></lower-tab>-->
    </b-card>
  </div>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex';
import { GRID_ID, LEAD_FREE_VALUES } from '@/shared/constants';
import FixedHeader from '@/shared/components/FixedHeader/indexNew';
import { date } from '@/shared/filters';
import PartForm from '../PartForm';
import { isNumberTypeAnnotation } from '@babel/types';
import LowerTab from '../LowerTabs/index';

export default {
  components: {
    FixedHeader,
    PartForm,
    LowerTab,
  },
	data() {
    return {
      gridId: GRID_ID.PART_DETAILS_INVENTORY_LIST,
      testings: [
        { name: 'Yes', value: true },
        { name: 'No', value: false },
      ],
      date,
      inStock: 0,
      allocated: 0,
      lastModified: null,
      isCopying: false
    }
  },
	computed: {
    ...mapGetters('parts', [
      'part',
    ]),
    pageTitle() {
      return `Part${this.isCopying ? ' Copy' : ''}: ${this.partId} - #${this.part ? this.part.partNumber: ''}`;
    },
		partId() {
      //return 17;
			return this.$route.params.id;
    },
    available() {
      return inStock - allocated;
    },
    partUpdated() {
      //console.log('computed: part updated');
      return this.lastModified ? this.lastModified : this.part ? this.part.dateModified : null;
    }
  },
  watch: {
    part() {

      console.log(this.part);

      //console.log('watching the part in the edit view');
      if(this.part != undefined && this.part != null){
        this.lastModified = this.part.dateModified;
      }
    }
  },
	methods: {
    onClose() {
      this.$router.push({ name: 'parts' })
    },
    onPartCreated(e) {
      // this.partId = e.id;
      if (this.isCopying && e.id > 0) {
        this.$router.push({ name: 'parts.edit', params: { id: e.id } })
      }
    },
    onPartUpdated(e) {
        //console.log('onPartUpdated')
        this.lastModified = e.dateModified;
        if (this.isCopying && e.id > 0) {
          this.$router.push({ name: 'parts.edit', params: { id: e.id } })
        }
    },
    onPartCopy(e) {
      this.isCopying = true;
    }
  },
}
</script>
